import * as XLSX from "xlsx";

// Başlık (etiket veya alan adı) -> alan eşlemesi
function buildMap(cols) {
  const m = {};
  cols.forEach(([field, label]) => {
    m[label.trim().toLowerCase()] = field;
    m[field.toLowerCase()] = field;
  });
  return m;
}

// .xlsx/.xls dosyasını satır nesnelerine çevirir (başlıkları alanlara eşler)
export async function parseXLSX(file, cols) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });
  const sheet = wb.Sheets[wb.SheetNames[0]];
  if (!sheet) return [];
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false, defval: "" });
  if (rows.length < 2) return [];
  const map = buildMap(cols);
  const idx = rows[0].map((h) => map[String(h || "").trim().toLowerCase()] || null);
  const out = [];
  for (let i = 1; i < rows.length; i++) {
    const cells = rows[i];
    if (!cells || cells.every((c) => String(c ?? "").trim() === "")) continue;
    const obj = {};
    idx.forEach((field, j) => { if (field) obj[field] = String(cells[j] ?? "").trim(); });
    out.push(obj);
  }
  return out;
}

// Başlık + örnek satırlarla hazır .xlsx şablon indirir
export function downloadXLSXTemplate(cols, filename, examples = []) {
  const header = cols.map((c) => c[1]);
  const body = examples.map((ex) => cols.map((c) => ex[c[0]] ?? ""));
  const ws = XLSX.utils.aoa_to_sheet([header, ...body]);
  ws["!cols"] = cols.map((c) => ({ wch: Math.max(16, c[1].length + 6) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Şablon");
  XLSX.writeFile(wb, filename);
}
